import React, { useEffect, useState } from 'react'

import { apiCreateWireSubscription } from 'services/BillingService'
import { Skeleton } from 'components/ui'
import WireTransferCheckoutForm from './form'

const WireTransferForm = ({ selectedPackage, termsOfUseContent }) => {
    const [subTotalAmount, setSubTotalAmount] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0)
    const [startingDate, setStartingDate] = useState('')
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const initCheckout = async () => {
            const response = await apiCreateWireSubscription({
                package_id: selectedPackage.id,
            })
            if (response.data) {
                setSubTotalAmount(response.data.data.subTotalAmount)
                setTotalAmount(response.data.data.totalAmount)
                setStartingDate(response.data.data.startingDate)
                setIsLoading(false)
            }
        }
        selectedPackage && initCheckout()
    }, [selectedPackage])

    return isLoading ? (
        <div className="flex flex-col gap-4">
            <Skeleton height={150} />
            <Skeleton height={40} />
        </div>
    ) : (
        selectedPackage && (
            <WireTransferCheckoutForm
                subTotalAmount={subTotalAmount}
                totalAmount={totalAmount}
                startingDate={startingDate}
                selectedPackage={selectedPackage}
                termsOfUseContent={termsOfUseContent}
            />
        )
    )
}

export default WireTransferForm
